import { useCallback, useEffect, useState } from 'react'
import { usePdfStore } from '@/store/usePdfStore'
import { ensureTranslationCompletion, hasTranslationCompletion, translate, type TranslationVars } from './i18n'

// Hook that returns a `t(key)` function bound to the current language. The
// language is read from the zustand store, so changing it via setLang will
// re-render any component that called useT() without manual wiring.
export function useT() {
  const lang = usePdfStore((s) => s.lang)
  const [version, setVersion] = useState(0)
  useEffect(() => {
    // Already loaded (or English): nothing to wait for, no extra render.
    if (hasTranslationCompletion(lang)) return
    let cancelled = false
    ensureTranslationCompletion(lang).then(() => {
      if (!cancelled) setVersion((v) => v + 1)
    }).catch(() => { /* fall back to the base translations */ })
    return () => { cancelled = true }
  }, [lang])
  const t = useCallback((key: string, vars?: TranslationVars) => {
    void version
    return translate(key, lang, vars)
  }, [lang, version])
  return t
}
